import { TaskFilterType } from "features/authSlice";
import { NeedStatus, NeedItem } from "pages/dashboard/home/dashboardService";

/** 
 * Additional Documentation need from API.
 * Identified by either `isDefault === true` OR `needRequestTypeId === "AdditionalDocumentation"`.
 * Both conditions needed to handle error states where needRequestTypeId is set but isDefault may vary.
 */
export const isAdditionalDocumentationTask = (item: NeedItem | undefined): boolean =>
  item?.isDefault === true;

/**
 * Returns a category `TaskFilterType` for a given `NeedItem` for the
 * purposes of counting tasks in the sidebar.
 * @param item 
 * @returns 
 */
export const getTaskStatusForCount = (item: NeedItem): TaskFilterType | null => {
  if (isAdditionalDocumentationTask(item)) {
    return null;
  }
  
  if (!item.needStatus) {
    return TaskFilterType.ToDo;
  }

  switch (item.needStatus.toLowerCase()) {
    case NeedStatus.ReviewNeeded.toLowerCase():
      return TaskFilterType.UnderReview;
    case NeedStatus.Satisfied.toLowerCase():
    case NeedStatus.Completed.toLowerCase():
      return TaskFilterType.Complete;
    case NeedStatus.New.toLowerCase():
    case NeedStatus.PendingDocuments.toLowerCase():
    case NeedStatus.Unknown.toLowerCase():
    default:
      return TaskFilterType.ToDo;
  }
};

/**
 * Returns a category `TaskFilterType` for a given `NeedItem` for the
 * purposes of sorting tasks into tabs.
 * "Additional Documentation" items always reside in the New Category
 * but are excluded from the sidebar count.
 */
export const getTaskStatus = (item: NeedItem): TaskFilterType => {
  if (isAdditionalDocumentationTask(item)) {
    return TaskFilterType.ToDo;
  }
  
  if (item.taskLoadErrorType) {
    return getTaskStatusForCount(item) ?? TaskFilterType.ToDo;
  }

  return getTaskStatusForCount(item) ?? TaskFilterType.ToDo;
};

export const isNeedCompleted = (item: NeedItem): boolean => {
  const statusLower = item.needStatus?.toLowerCase();
  return statusLower === NeedStatus.Satisfied.toLowerCase() || statusLower === NeedStatus.Completed.toLowerCase();
};

export const getEffectiveTaskStatus = (item: NeedItem, heldIds: string[] = []): TaskFilterType => {
  if (heldIds?.includes(item.id) && !isNeedCompleted(item)) {
    return TaskFilterType.UnderReview;
  }
  return getTaskStatus(item);
};

export const getEffectiveTaskStatusForCount = (item: NeedItem, heldIds: string[] = []): TaskFilterType | null => {
  if (isAdditionalDocumentationTask(item)) {
    return null;
  }
  return getEffectiveTaskStatus(item, heldIds);
};